import * as crypto from 'crypto';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalizableError } from 'src/app/models/LocalizableError';

@Injectable({
  providedIn: 'root'
})
export class MercanetService {

  public error: LocalizableError;

  constructor(private http: HttpClient) { }

  sendPostRequestPhp(total, currencySymbol, registrationData, readableEventId, purchaseId) {
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');
    currencySymbol = "EUR";
    registrationData.total = total;
    registrationData.currencySymbol = currencySymbol;
    registrationData.purchaseId = purchaseId;
    registrationData.readableEventId = readableEventId;
    var dataToPost = JSON.stringify(registrationData);
    var urlPaiement = "/mercanet/";
    return this.http.post(urlPaiement, dataToPost, { headers: headers })
  }
}
